import EnviromentBadge from 'common/enviroment-badge';
import StagLogoSVG from 'common/stag-logo-svg';
import { useAuth } from 'context/auth-context';
import useApps from 'hooks/use-app';
import { Link } from 'react-router-dom';
import AppSelector from './AppSelector';
import UserMenu from './UserMenu';

const Header = () => {
  const { user, isAuthenticated, isLoading, signOut } = useAuth();
  const { currentApp } = useApps();
  return (
    <header className="text-gray-600 body-font">
      <div className="flex flex-wrap px-4 py-2 flex-col md:flex-row items-center">
        <div className="flex items-end gap-2">
          <Link to={`/${currentApp ? currentApp.key : ''}`}>
            <div className="w-20 aspect-[165/50]">
              <StagLogoSVG />
            </div>
          </Link>
          <EnviromentBadge />
        </div>

        <div className="md:ml-auto flex flex-wrap items-center text-base justify-center">
          {isAuthenticated ? (
            <nav className="md:ml-auto md:mr-auto flex flex-wrap">
              <AppSelector />
            </nav>
          ) : null}
        </div>

        <div className="ml-2 inline-flex items-center bg-gray-100 border-0 py-1 focus:outline-none rounded text-base">
          {isLoading ? (
            '..'
          ) : isAuthenticated ? (
            <UserMenu user={user} signOut={signOut} />
          ) : null}
        </div>
      </div>
    </header>
  );
};

export default Header;
